import { takeLatest, select, put, call, all } from "redux-saga/effects";
import { Customers, Stores } from "@grandvisionhq/api-client";
import { Selectors, State, getToken } from "@grandvisionhq/auth";
import { ApiConfigSelectors } from "@grandvisionhq/state";
import { FETCH_LIST, FETCH_SIGNED, fetchListFailed, fetchListSuccess, fetchSignedFailed, fetchSignedSucccess } from "./actions.js";
function getStoreResult(apiConfig, storeId) {
  if (!apiConfig || !storeId) {
    return;
  }
  return Stores.getDetailsByCode(apiConfig.storesUrl, {
    code: storeId
  }).catch(console.error);
}
function* onFetchList() {
  const auth = yield select(Selectors.getAuth);
  if (!State.isLoggedIn(auth)) {
    yield put(
      fetchListFailed(
        new Error(`Can't fetch prescriptions when user isn't logged-in`)
      )
    );
    return;
  }
  try {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
      yield put(
        fetchListFailed({
          message: `Can't fetch stores without API Config`
        })
      );
      return;
    }
    const token = yield call(getToken);
    const response = yield call(
      Customers.Prescriptions.list,
      auth.apiUrl,
      token,
      {
        customerId: auth.userId
      }
    );
    const storeFetchResults = response.reduce((m, prescription) => {
      if (!prescription.storeId) {
        return m;
      }
      return {
        ...m,
        [prescription.storeId]: call(getStoreResult, apiConfig, prescription.storeId)
      };
    }, {});
    const storeResponse = yield all(storeFetchResults);
    const result = response.map((prescription) => ({
      ...prescription,
      storeName: prescription.storeId && storeResponse[prescription.storeId]?.storeName
    }));
    yield put(fetchListSuccess(result));
  } catch (err) {
    yield put(fetchListFailed({ ...err }));
  }
}
function* onFetchSigned() {
  const auth = yield select(Selectors.getAuth);
  if (!State.isLoggedIn(auth)) {
    yield put(
      fetchSignedFailed(
        new Error(`Can't fetch signed prescriptions when user isn't logged-in`)
      )
    );
    return;
  }
  try {
    const token = yield call(getToken);
    const response = yield call(
      Customers.Prescriptions.signedPrescriptions,
      auth.apiUrl,
      token,
      {
        customerId: auth.userId
      }
    );
    yield put(fetchSignedSucccess(response.prescriptionTokens));
  } catch (err) {
    yield put(fetchSignedFailed({ ...err }));
  }
}
const prescriptionsSagas = [
  takeLatest(FETCH_LIST, onFetchList),
  takeLatest(FETCH_SIGNED, onFetchSigned)
];
export {
  prescriptionsSagas as default,
  getStoreResult,
  onFetchList,
  onFetchSigned
};
//# sourceMappingURL=sagas.js.map
